import { PaginatedTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { StationAvatar } from '@app/components/base/stations/StationAvatar';
import { LDateTime } from '../../../../../../../components/date/LDateTime';
import { ReportResultProps } from '../../../../../../../core/reports/types';
import { GlobalAudiosNoMatchesReport } from '../types';

export function GlobalAudiosNoMatchesReportResult(
  p: ReportResultProps<GlobalAudiosNoMatchesReport>,
) {
  const { $t } = useIntl();

  return (
    <PaginatedTable
      columns={[
        {
          Header: $t({
            id: 'audit.props.customId',
            defaultMessage: 'ID material',
          }),
          accessor: (item) => item.audio.customId,
          w: 15,
        },
        {
          Header: $t({
            id: 'common.entities.group',
            defaultMessage: 'Grupo',
          }),
          accessor: (item) => item.audio.stationsGroup?.name,
          w: 20,
        },
        {
          Header: $t({
            id: 'common.station',
            defaultMessage: 'Emisora',
          }),
          accessor: (item) => {
            const station = item.audio.station;

            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {station && <StationAvatar stationId={station.id} size={20} />}
                {station?.name}
              </Box>
            );
          },
          w: 20,
        },
        {
          Header: $t({
            id: 'common.createdAt',
            defaultMessage: 'Creado',
          }),
          accessor: (item) => <LDateTime value={item.audio.createdAt} />,
          w: 20,
        },
        {
          Header: $t({
            id: 'common.updatedAt',
            defaultMessage: 'Actualizado',
          }),
          accessor: (item) => <LDateTime value={item.audio.updatedAt} />,
          w: 20,
        },
      ]}
      data={p.result.items}
    />
  );
}
